import { MARKET, TMarket } from '@/common/constants/markets';
import { TMenhirInsurancePaymentMethod } from '@/common/integrations/menhir/employee/insurance/insurance.types';

export function getFaqsI18nKey({
  market,
  companyPaysAll,
  paymentMethod,
}: {
  market: TMarket;
  companyPaysAll: boolean;
  paymentMethod?: TMenhirInsurancePaymentMethod;
}) {
  switch (market) {
    case MARKET.PT:
      if (companyPaysAll) {
        return 'dashboard.insurance.simulate_family.step.confirm_details.faqs.pay_none.list';
      }
      return `dashboard.insurance.simulate_family.step.confirm_details.faqs.${paymentMethod}.list`;
    case MARKET.ES:
      if (companyPaysAll) {
        return 'dashboard.insurance.es.simulate_family.step.confirm_details.faqs.pay_none.list';
      }
      return 'dashboard.insurance.es.simulate_family.step.confirm_details.faqs.list';
    default:
      return '';
  }
}
